import styled from 'styled-components';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';

export const LoaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
`;

export const StyledIcon = styled(Icon)`
	user-select: none;

	&:hover {
		cursor: pointer;
	}
`;

export const DashboardGridLayout = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	overflow: hidden;
	height: 100%;
	width: 100%;
`;
